export const VisualizzaPAFilterComponent = {
    template: require('./visualizza-pa-filter.html'),
    controller: class VisualizzaPAFilterComponent {

        private statusList: Array<string>;
        private filterTemp: any;

        private dpOpened: any;

        private resolve: any;
        private close: any;
        private dismiss: any;

        private settings: any;

        constructor(
        ) {
            /* tslint:disable:no-string-literal */
            this.statusList = ['Generata', 'Trasmessa allo SdI', 'Scartata', 'Non ancora consegnata', 'Consegnata',
              'Accettata', 'Rifiutata', 'Decorsi i termini', 'Non recapitabile', 'Presa in carico', 'Nel cassetto',
              'ERRORE TRASMISSIONE', 'Rielaborata'];
        }

        $onInit(): void {
            this.settings = this.resolve.filter;
            this.filterTemp = JSON.parse(JSON.stringify(this.settings.filter));
        }

        clearFilter() {
            this.filterTemp.status = '';
            this.filterTemp.number = '';
            this.filterTemp.idSdi = '';
            this.filterTemp.dataFrom = '';
            this.filterTemp.dataTo = '';
            this.filterTemp.sendingId = '';
            this.filterTemp.object = '';
            this.filterTemp.cessionary = '';
            this.filterTemp.fiscalId = '';
            this.filterTemp.fiscalCode = '';
            this.filterTemp.receiverCode = '';
            this.filterTemp.reference = '';
            this.filterTemp.onlyLastVersion = true;
            this.filterTemp.sendingId = '';
            this.filterTemp.pageNumber = 1;
            this.filterTemp.option = '';
        }

        updateDateField(field: string, value: Date) {
            this.filterTemp[field] = value;
        }

        save() {
            this.settings.filter = this.filterTemp;
            this.settings.filter.pageNumber = 1;
            this.close({ $value: this.settings });
        }

        cancel() {
            this.dismiss();
        }
    },
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/visualizza-pa-filter/visualizza-pa-filter.ts